export const appThemes = ["standard", "nevo", "biox"];
export const defaultAppTheme = "standard";
export function isAppTheme(themeName) {
    return appThemes.includes(themeName);
}
export function resolveAppTheme(themeName) {
    return isAppTheme(themeName) ? themeName : defaultAppTheme;
}
export function applyTheme(themeName) {
    const theme = resolveAppTheme(themeName);
    document.documentElement.dataset.theme = theme;
    return theme;
}
//# sourceMappingURL=theme.js.map